<template>
  <div class="virtual-balance">
    <img src="@/assets/coinsBox.gif" class="gif" v-show="isClaimButtonActive" alt="">
    <div class="giff" v-show="!isClaimButtonActive"></div>
    <div class="coins-wrap" v-show="!isClaimButtonActive">
      <img src="@/assets/money-bag.gif" class="box-img" />
    </div>
    {{ formattedBalance }}
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters(['virtualBalance', 'isClaimButtonActive']),
    formattedBalance() {
      return this.virtualBalance.toFixed(8);
    }
  },
  watch: {
    virtualBalance(newBalance) {
      if (newBalance >= this.dailyStf) {
        this.$store.commit('STOP_VIRTUAL_BALANCE_UPDATE');
        this.$store.commit('START_LOST_REWARD_UPDATE');
      }
    }
  }
}
</script>

<style scoped>
.virtual-balance {
  font-size: 3rem;
  color: #ffa500;
  text-align: center;
  display: flex;
  flex-direction: column;
  font-family: 'Digital-7', sans-serif;
  margin-top: -120px;
}

.gif {
  width: 180px;
  margin: auto;
  margin-bottom: 50px;
}

.box-img {
  width: 180px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.coins-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
